export default "__VITE_ASSET__CRO7Cuvv__"